import React from 'react';

import {WBAgentChatButton} from './WBAgentChatButton';
import {WBAgentDrawerHost} from './WBAgentDrawerHost';

const noop = () => undefined;

/**
 * The header button as it appears on the full-page ARIA route: shown as
 * active and disabled, since the page itself is the open surface.
 */
export const WBAgentActivePageButton = () => (
  <WBAgentChatButton
    aria-expanded
    disableTooltip
    isDisabled
    hideIntroTooltip={noop}
    unseenSettledThread={null}
  />
);

/**
 * What a header renders for ARIA: the drawer host (toggle button plus docked
 * drawer), or only the disabled button while the full-page ARIA route is
 * showing, so the drawer runtime stays off that route where AriaPage owns the
 * runtime instead.
 *
 * The caller decides which; this component reads no router state. Only the
 * Forge nav mount (ariaNavMount.tsx) ever passes `isAriaPageActive`: the
 * full-page route exists to serve the shell's `/aria` product and is not
 * linked from the legacy header, which renders the drawer host unconditionally.
 */
export const WBAgentNav = ({
  isAriaPageActive = false,
}: {
  isAriaPageActive?: boolean;
}) => (isAriaPageActive ? <WBAgentActivePageButton /> : <WBAgentDrawerHost />);
